import { render, staticRenderFns } from "./AssignmentEditModal.vue?vue&type=template&id=3b9d03aa&scoped=true"
import script from "./AssignmentEditModal.vue?vue&type=script&lang=js"
export * from "./AssignmentEditModal.vue?vue&type=script&lang=js"
import style0 from "./AssignmentEditModal.vue?vue&type=style&index=0&id=3b9d03aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9d03aa",
  null
  
)

export default component.exports